import {FC} from "react";

import {useFrame} from "@react-three/fiber";

import {useGame} from "~/contexts/game-manager/GameManagerProvider";
import {useServerTime} from "~/contexts/time/ServerTimeProvider";

/**
 * A simple component that connects the GameManager to the react-three-fiber
 * render loop. It must be rendered inside a <Canvas>.
 */
const GameLoopRunner: FC = () => {
  const {gameManager} = useGame();
  const getEstimatedServerTime = useServerTime(); // Assume you've extracted this

  useFrame(() => {
    if (gameManager) {
      const serverNow = getEstimatedServerTime();
      gameManager.update(serverNow);
    }
  }, -1);

  return null; // This component renders nothing.
};

export default GameLoopRunner;
